// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarOrcamentoServicosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/buscar_orcamento_servicos
 *
 * Returns two arrays of services for a given commitment:
 * - compromisso_servicos: services linked to the commitment (reuses
 *   Agenda_BuscarCompromissoServicoCompromissoRow because the per-row
 *   shape comes from Compromissos_model::pega_servicos_compromisso).
 * - orcamentos_servicos: all services from the associated budget
 *   (Agenda_BuscarOrcamentoServicosOrcamentoServicoRow shape from
 *   Orcamentos_model::buscar_servicos_orcamento).
 */
import type { Agenda_BuscarCompromissoServicoCompromissoRow } from './Agenda_BuscarCompromissoServicoCompromissoRow'
import type { Agenda_BuscarOrcamentoServicosOrcamentoServicoRow } from './Agenda_BuscarOrcamentoServicosOrcamentoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarOrcamentoServicosResponseDados {
compromisso_servicos: Agenda_BuscarCompromissoServicoCompromissoRow[]
orcamentos_servicos: Agenda_BuscarOrcamentoServicosOrcamentoServicoRow[]
}

export type Agenda_BuscarOrcamentoServicosResponse = ApiResponse<Agenda_BuscarOrcamentoServicosResponseDados>;

registerResponseContract('Agenda_BuscarOrcamentoServicosResponse', {
  compromisso_servicos: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:              { type: 'number',  required: true },
      servico_id:                        { type: 'number',  required: true },
      compromisso_servico_id:            { type: 'number',  required: true },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: true },
      compromisso_servico_valor:         { type: 'number',  required: true },
      compromisso_servico_qtd:           { type: 'number',  required: true },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      compromisso_servico_observacao:    { type: 'string',  required: false },
      servico_nome:                      { type: 'string',  required: true },
      tem_imagens_antes:                 { type: 'boolean', required: false },
      tem_imagens_depois:                { type: 'boolean', required: false },
      imagens:                           { type: 'string',  required: false },
    },
  },
  orcamentos_servicos: {
    type: 'array',
    required: true,
    items: {
      orcamento_servico_id:            { type: 'number',  required: true },
      orcamento_id:                    { type: 'number',  required: false },
      servico_id:                      { type: 'number',  required: false },
      servico_valor:                   { type: 'number',  required: false },
      orcamento_servico_qtd:           { type: 'number',  required: false },
      orcamento_servico_user_id:       { type: 'string',  required: false },
      orcamento_servico_tipo:          { type: 'number',  required: false },
      orcamento_servico_status:        { type: 'number',  required: true },
      orcamento_servico_data_cadastro: { type: 'string',  required: false },
      orcamento_franquia_id:           { type: 'number',  required: true },
      servico_nome:                    { type: 'string',  required: true },
      servicoscategoria_id:            { type: 'number',  required: false },
    },
  },
})
